import WorkflowStatus, { WorkflowStatusType } from './workflowStatus';

export interface UploadStatusType extends Record<string, any> {
  key: string;
  message: string;
  isValid: WorkflowStatusType;
  isSent: WorkflowStatusType;
  isAccepted: WorkflowStatusType;
}

export type StatusName =
  | 'VALIDATED'
  | 'MISSING_ACTION_SUMMARY'
  | 'NOT_VALIDATED'
  | 'CANCELLED'
  | 'WAITING_FOR_ACCEPTANCE'
  | 'IN_PROGRESS'
  | 'ACCEPTED'
  | 'REFUSED'
  | 'UNKNOWN'
  | 'ACCEPTED_AND_DISTRIBUTED';

const UploadStatus: Record<StatusName, UploadStatusType> = {
  VALIDATED: {
    key: 'VALIDATED',
    message: 'upload_status.value.validated',
    isValid: WorkflowStatus.FINISHED_SUCCESS,
    isSent: WorkflowStatus.NOT_STARTED,
    isAccepted: WorkflowStatus.NOT_STARTED,
  },
  MISSING_ACTION_SUMMARY: {
    key: 'MISSING_ACTION_SUMMARY',
    message: 'upload_status.value.missing_action_summary',
    isValid: WorkflowStatus.IN_PROGRESS,
    isSent: WorkflowStatus.NOT_STARTED,
    isAccepted: WorkflowStatus.NOT_STARTED,
  },
  NOT_VALIDATED: {
    key: 'NOT_VALIDATED',
    message: 'upload_status.value.not_validated',
    isValid: WorkflowStatus.FINISHED_FAILURE,
    isSent: WorkflowStatus.NOT_STARTED,
    isAccepted: WorkflowStatus.NOT_STARTED,
  },
  CANCELLED: {
    key: 'CANCELLED',
    message: 'upload_status.value.cancelled',
    isValid: WorkflowStatus.FINISHED_SUCCESS,
    isSent: WorkflowStatus.FINISHED_FAILURE,
    isAccepted: WorkflowStatus.NOT_STARTED,
  },
  WAITING_FOR_ACCEPTANCE: {
    key: 'WAITING_FOR_ACCEPTANCE',
    message: 'upload_status.value.waiting_for_acceptance',
    isValid: WorkflowStatus.FINISHED_SUCCESS,
    isSent: WorkflowStatus.FINISHED_SUCCESS,
    isAccepted: WorkflowStatus.NOT_STARTED,
  },
  IN_PROGRESS: {
    key: 'IN_PROGRESS',
    message: 'upload_status.value.in_progress',
    isValid: WorkflowStatus.FINISHED_SUCCESS,
    isSent: WorkflowStatus.FINISHED_SUCCESS,
    isAccepted: WorkflowStatus.IN_PROGRESS,
  },
  ACCEPTED: {
    key: 'ACCEPTED',
    message: 'upload_status.value.accepted',
    isValid: WorkflowStatus.FINISHED_SUCCESS,
    isSent: WorkflowStatus.FINISHED_SUCCESS,
    isAccepted: WorkflowStatus.FINISHED_SUCCESS,
  },
  REFUSED: {
    key: 'REFUSED',
    message: 'upload_status.value.refused',
    isValid: WorkflowStatus.FINISHED_WARNING,
    isSent: WorkflowStatus.FINISHED_SUCCESS,
    isAccepted: WorkflowStatus.FINISHED_FAILURE,
  },
  UNKNOWN: {
    key: 'UNKNOWN',
    message: 'upload_status.value.unknown',
    isValid: WorkflowStatus.FINISHED_UNKNOWN,
    isSent: WorkflowStatus.NOT_STARTED,
    isAccepted: WorkflowStatus.NOT_STARTED,
  },
  ACCEPTED_AND_DISTRIBUTED: {
    key: 'ACCEPTED_AND_DISTRIBUTED',
    message: 'upload_status.value.accepted_and_distributed',
    isValid: WorkflowStatus.FINISHED_SUCCESS,
    isSent: WorkflowStatus.FINISHED_SUCCESS,
    isAccepted: WorkflowStatus.FINISHED_SUCCESS,
  },
};
export default UploadStatus;
